<div
  [formGroup]="form"
  class="add-payment">
  <h2 class="headline">
    {{ "PAYMENT_VIEW_PAGE.MODAL.TITLE_EDIT" | translate }}
  </h2>
  <div class="scroll-block">
    <div class="add-payment__head">
      <div
        [class.error]="form.get('accountRecipient')?.invalid && form.get('accountRecipient')?.touched"
        class="input-block">
        <input
          formControlName="accountRecipient"
          mask="SS00AAAAAAAAAAAAAAAA"
          id="account"
          class="input"
          type="text"
          maxlength="20"
          placeholder=" " />
        <label
          for="account"
          class="placeholder">
          {{ "PAYMENT_VIEW_PAGE.MODAL.ACCOUNT_RECIPIENT" | translate }}
        </label>
        <ng-container *ngIf="form.get('accountRecipient')?.invalid && form.get('accountRecipient')?.touched">
          <span
            *ngIf="accountRecipientRequiredError"
            class="input-block__error">
            {{ "PAYMENT_VIEW_PAGE.ERROR.PAYMENT_ACCOUNT_REQUIRED" | translate }}
          </span>
        </ng-container>
      </div>
      <div class="add-payment__head-line">
        <div class="left">
          <button
            [disabled]="!permissionService.hasPermission(['PAYMENT_TYPE_EDIT'])"
            [class.active]="isActivePayment"
            (click)="isActivePayment = true"
            type="button"
            class="radio-btn active">
            {{ "PAYMENT_VIEW_PAGE.MODAL.IS_ACTIVE" | translate }}
          </button>
        </div>
        <div class="right">
          <button
            [disabled]="!permissionService.hasPermission(['PAYMENT_TYPE_EDIT'])"
            [class.active]="!isActivePayment"
            (click)="isActivePayment = false"
            type="button"
            class="radio-btn">
            {{ "PAYMENT_VIEW_PAGE.MODAL.IS_BLOCKED" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="add-payment__line">
      <div class="add-payment__line-left">
        <div
          [class.error]="form.get('paymentNameFormControl')?.invalid && form.get('paymentNameFormControl')?.touched"
          class="input-block">
          <input
            formControlName="paymentNameFormControl"
            id="paymentName"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="paymentName"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.NAME_VIEW" | translate }}
          </label>
          <ng-container *ngIf="form.get('paymentNameFormControl')?.invalid && form.get('paymentNameFormControl')?.touched">
            <span
              *ngIf="paymentNameRequiredError"
              class="input-block__error">
              {{ "PAYMENT_VIEW_PAGE.ERROR.PAYMENT_NAME_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="add-payment__line-right">
        <div
          [class.error]="form.get('recipientFormControl')?.invalid && form.get('recipientFormControl')?.touched"
          class="input-block">
          <input
            formControlName="recipientFormControl"
            id="recipient"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="recipient"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.RECIPIENT" | translate }}
          </label>
          <ng-container *ngIf="form.get('recipientFormControl')?.invalid && form.get('recipientFormControl')?.touched">
            <span
              *ngIf="recipientRequiredError"
              class="input-block__error">
              {{ "PAYMENT_VIEW_PAGE.ERROR.RECIPIENT_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="add-payment__line">
      <div class="add-payment__line-left">
        <div
          [class.error]="form.get('bankRecipient')?.invalid && form.get('bankRecipient')?.touched"
          class="input-block">
          <input
            formControlName="bankRecipient"
            id="bankRecipient"
            mask="AAAAAAAA"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="bankRecipient"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.BANK_RECIPIENT" | translate }}
          </label>
          <ng-container *ngIf="form.get('bankRecipient')?.invalid && form.get('bankRecipient')?.touched">
             <span
               *ngIf="bankRecipientRequiredError"
               class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BANK_RECIPIENT_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="bankRecipientFormatError && !bankRecipientRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BANK_RECIPIENT_FORMAT" | translate }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="add-payment__line-right">
        <div
          [class.error]="form.get('binFormControl')?.invalid && form.get('binFormControl')?.touched"
          class="input-block">
          <input
            formControlName="binFormControl"
            id="bin"
            mask="000000000000"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="bin"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.BIN" | translate }}
          </label>
          <ng-container *ngIf="(form.get('binFormControl')?.invalid && form.get('binFormControl')?.touched) || form.get('binFormControl')?.value">
            <span
              *ngIf="binRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="binFormatError && !binRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_MIN" | translate }}
            </span>
            <span
              *ngIf="!binFormatError && !binRequiredError && form.get('binFormControl')?.hasError('iinNotValid')"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.BIN_INVALID" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="add-payment__line">
      <div class="add-payment__line-left">
        <div
          [class.error]="form.get('codeFormControl')?.invalid && form.get('codeFormControl')?.touched"
          class="input-block">
          <input
            formControlName="codeFormControl"
            id="code"
            mask="000000"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="code"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.CODE" | translate }}
          </label>
          <ng-container *ngIf="(form.get('codeFormControl')?.invalid && form.get('codeFormControl')?.touched) || form.get('codeFormControl')?.value">
            <span
              *ngIf="codeFormFormatError"
              class="input-block__error">
              {{ "PAYMENT_VIEW_PAGE.ERROR.CODE_MIN" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
      <div class="add-payment__line-right">
        <div
          [class.error]="form.get('moneyRemitter')?.invalid && form.get('moneyRemitter')?.touched"
          class="input-block">
          <input
            formControlName="moneyRemitter"
            id="moneyRemitter"
            mask="00"
            class="input"
            type="tel"
            placeholder=" " />
          <label
            for="moneyRemitter"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.CODE_SENDER" | translate }}
          </label>
          <ng-container *ngIf="form.get('moneyRemitter')?.invalid && form.get('moneyRemitter')?.touched">
            <span
              *ngIf="moneyRemitterFormatError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.CODE_SENDER_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="add-payment__line">
      <div class="add-payment__line-left">
        <div
          [class.error]="form.get('codeDestinationFormControl')?.invalid && form.get('codeDestinationFormControl')?.touched"
          class="input-block">
          <input
            formControlName="codeDestinationFormControl"
            id="codeDestination"
            mask="000"
            inputmode="numeric"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="codeDestination"
            class="placeholder">
            {{ "PAYMENT_VIEW_PAGE.MODAL.CODE_DESTINATION" | translate }}
          </label>
          <ng-container *ngIf="form.get('codeDestinationFormControl')?.invalid && form.get('codeDestinationFormControl')?.touched">
            <span
              *ngIf="codeDestinationRequiredError"
              class="input-block__error">
              {{ "PAYMENT_VIEW_PAGE.ERROR.CODE_DESTINATION_REQUIRED" | translate }}
            </span>
            <span
              *ngIf="codeDestinationFormatError"
              class="input-block__error">
              {{ "PAYMENT_VIEW_PAGE.ERROR.CODE_DESTINATION_MIN" | translate }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="add-payment__line-right">
        <div
          [class.error]="form.get('infoLine')?.invalid && form.get('infoLine')?.touched"
          class="input-block">
          <input
            formControlName="infoLine"
            id="infoLine"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="infoLine"
            class="placeholder">
            {{ "COMPANY_DATA_PAGE.PAYMENT_PURPOSE" | translate }}
          </label>
          <ng-container *ngIf="form.get('infoLine')?.invalid && form.get('infoLine')?.touched">
            <span
              *ngIf="infoLineRequiredError"
              class="input-block__error">
              {{ "COMPANY_DATA_PAGE.REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="add-payment__btn-block">
    <button
      [disabled]="form.invalid || isSending"
      (click)="sendForm()"
      type="submit"
      class="btn btn-accent">
      {{ "PAYMENT_VIEW_PAGE.MODAL.SAVE" | translate }}
    </button>
    <button
      (click)="closeModal()"
      type="button"
      class="btn btn-light">
      {{ "PAYMENT_VIEW_PAGE.MODAL.CANCEL" | translate }}
    </button>
  </div>
</div>
